import { useCallback } from 'react';

import {
  setIsVideoModalVisible,
  setVideoInfo,
  useVideoModalStateSelector,
} from 'features/video-modal';
import { useAppDispatch } from 'shared/lib/redux';
import { VideoInfo } from 'shared/lib/plyr-video-utils';

export const useVideoModalState = () => {
  const dispatch = useAppDispatch();

  const { isVideoModalVisible, videoInfo } = useVideoModalStateSelector();

  const showVideoModal = useCallback(
    (info: VideoInfo) => {
      dispatch(setIsVideoModalVisible(true));
      dispatch(setVideoInfo(info));
    },
    [dispatch],
  );

  const hideVideoModal = useCallback(
    () => dispatch(setIsVideoModalVisible(false)),
    [dispatch],
  );

  return {
    isVideoModalVisible,
    videoInfo,
    showVideoModal,
    hideVideoModal,
  };
};
